const atMinuteOfDay = (base, minute) => {
  const d = new Date(base);
  d.setHours(Math.floor(minute / 60), minute % 60, 0, 0);
  return d;
};

const applyOffset = (start, def, sign) => {
  const d = new Date(start);
  if (def.interval_unit === 'minutes') {
    d.setMinutes(start.getMinutes() + sign * def.interval_value);
  } else if (def.interval_unit === 'hours') {
    d.setHours(start.getHours() + sign * def.interval_value);
  }
  return d;
};

const dayRuleTimes = (eventTimeDefaults, wday) => {
  const rules = (eventTimeDefaults && eventTimeDefaults.day_rules) || [];
  const rule = rules.find(r => (r.days || []).map(Number).includes(wday));
  return (rule && rule.times) || {};
};

export const applyDefaultStart = (eventTimeDefaults, date) => {
  const pins = dayRuleTimes(eventTimeDefaults, date.getDay());
  const startMin = pins.start_time != null
    ? Number(pins.start_time)
    : (eventTimeDefaults && eventTimeDefaults.default_start_minute != null ? Number(eventTimeDefaults.default_start_minute) : null);
  return startMin != null ? atMinuteOfDay(date, startMin) : date;
};

export const resolveTimeDefaults = (confirm, doorsTimeDefault, eventEndTimeDefault, eventTimeDefaults, canUpdateDoorsTime, canUpdateEventEndTime) => {
  if (confirm.start_time === undefined || confirm.start_time === null) { return null; }

  const start = new Date(confirm.start_time);
  const pins = dayRuleTimes(eventTimeDefaults, start.getDay());
  const changed = { ...confirm };

  if (canUpdateDoorsTime) {
    if (pins.door_time != null) {
      changed.door_time = atMinuteOfDay(start, Number(pins.door_time));
    } else if (doorsTimeDefault) {
      changed.door_time = applyOffset(start, doorsTimeDefault, -1);
    }
  }

  if (canUpdateEventEndTime) {
    if (pins.end_time != null) {
      const pinnedEnd = atMinuteOfDay(start, Number(pins.end_time));
      if (pinnedEnd < start) { pinnedEnd.setDate(pinnedEnd.getDate() + 1); }
      changed.end_time = pinnedEnd;
    } else if (eventEndTimeDefault) {
      changed.end_time = applyOffset(start, eventEndTimeDefault, +1);
    }
  }

  return changed;
};
